import { Trans, useTranslation } from 'i18n';
import { Typography } from 'ui';

import { guideImages } from '../../data';
import { GuideImage } from '../GuideImage/GuideImage';
import { GuideTitle } from '../GuideTitle/GuideTitle';

export const PartOne = ({ obfuscateAi }: { obfuscateAi: boolean }) => {
  const { t } = useTranslation('features');

  return (
    <>
      <GuideTitle obfuscateAi={obfuscateAi} />
      <GuideImage src={guideImages.briquetteDistance} alt={t('helpGuides.aiBriquette.partOne.imageAlt')} />
      <Typography>
        <Trans
          namespace="features"
          i18nKey="helpGuides.aiBriquette.partOne.instructions"
          components={{
            bold: <Typography component="span" fontWeight="bold" />,
          }}
        />
      </Typography>
    </>
  );
};
